import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";

function notificationsController($scope, notificationStreamService, notificationStreamUtility, hybridService, eventStreamService, urlService, chatDispatchService, $document, $log) {
    "ngInject";

    function sendEventStream(eventName, notificationId, eventType) {
        var notification = $scope.notifications[notificationId];
        var property = angular.copy($scope.library.eventStreamMetaData);
        property.notificationType = notification.notificationSourceType;
        eventStreamService.sendEventWithTarget(eventName,
            eventType,
            property);
    }

    var acceptFriendErrors = {
        ownFriendsLimitHit: 12,
        othersFriendsLimitHit: 13
    };

    $scope.acceptFriend = function (friendRequestId, notificationId, event) {
        $log.debug("---------------- acceptFriend --------- ");
        var notification = $scope.notifications[notificationId];
        $scope.interactNotification(notification);
        notificationStreamService.acceptFriend($scope.library.currentUserId, friendRequestId)
            .then(
                function (data) {
                    if (angular.isUndefined(data) || data.success) {
                        var notification = $scope.notifications[notificationId];
                        notification.friendRequestActionType = notificationStreamUtility.friendRequestActionType.chatBtn;
                        notification.metadataCollection[0].IsAccepted = true;
                        notification.isFlipped = true;
                        $document.triggerHandler("Roblox.Friends.CountChanged");
                        sendEventStream(eventStreamService.eventNames.notificationStream.acceptFriendRequest, notificationId, event.type);
                    } else {
                        if (data.errorId === acceptFriendErrors.ownFriendsLimitHit) {
                            $scope.layout.errorText = notificationStreamUtility.normalizeSelfMaxFriendsErrorText();
                            $scope.layout.errorBannerEnabled = true;
                        } else if (data.errorId === acceptFriendErrors.othersFriendsLimitHit) {
                            $scope.layout.errorText = notificationStreamUtility.normalizeOtherMaxFriendsErrorText();
                            $scope.layout.errorBannerEnabled = true;
                        }
                    }
                });
    };

    $scope.ignoreFriend = function (friendRequestId, notificationId, event) {
        $log.debug("---------------- ignoreFriend --------- ");
        var notification = $scope.notifications[notificationId];
        $scope.interactNotification(notification);
        notificationStreamService.ignoreFriend($scope.library.currentUserId, friendRequestId)
            .then(
                function () {
                    var notification = $scope.notifications[notificationId];
                    notification.isSlideOut = true;
                    sendEventStream(eventStreamService.eventNames.notificationStream.ignoreFriendRequest, notificationId, event.type);
                });
    }

    $scope.removeNotification = function (notificationId) {
        $log.debug("---------------- removeNotification --------- notificationId:  " + notificationId);
        var index = $scope.notificationIds.indexOf(notificationId);
        $scope.notificationIds.splice(index, 1);
        delete $scope.notifications[notificationId];
    }

    $scope.chat = function (friendId, notificationId, event) {
        if (!$scope.library.isChatDisabledByPrivacySetting) {
            var notification = $scope.notifications[notificationId];
            $scope.interactNotification(notification);
            var chatPermissionVerifier = chatDispatchService.buildPermissionVerifier($scope.library);
            chatPermissionVerifier.uwpApp.hybridRequired = true;
            chatDispatchService.startChat(friendId, chatPermissionVerifier);
            sendEventStream(eventStreamService.eventNames.notificationStream.chat, notificationId, event.type);
        }
    }

    $scope.interactNotification = function (notification) {
        if (!notification.isInteracted) {
            notificationStreamService.markInteracted(notification.id)
                .then(
                    function () {
                        notification.isInteracted = true;
                    });
        }
    }

    $scope.clickCard = function (notification) {
        var url = "";
        var params = {};
        switch (notification.notificationSourceType) {
            case notificationStreamUtility.notificationSourceType.friendRequestReceived:
                $scope.interactNotification(notification);
                if (notification.eventCount > 1 || (notification.metadataCollection.length === 0)) {
                    url = notificationStreamUtility.links.friendRequestLink;
                    if ($scope.library.inApp) {
                        params = {
                            feature: notificationStreamUtility.links.friendRequestTabName,
                            urlPath: url
                        };
                        hybridService.navigateToFeature(params, function (status) {
                            $log.debug("openUserFriendsPage ---- status:" + status);
                        });
                    } else {
                        window.location.href = urlService.getAbsoluteUrl(url);
                    }
                } else if (notification.metadataCollection && notification.metadataCollection.length > 0) {
                    var validData = notification.metadataCollection[0];
                    url = notificationStreamUtility.links.profileLink;
                    var userId = validData.SenderUserId;
                    if ($scope.library.inApp) {
                        hybridService.openUserProfile(parseInt(userId), function (status) {
                            $log.debug("openUserProfile ---- status:" + status);
                        });
                    } else {
                        window.location.href = notificationStreamUtility.getAbsoluteUrl(url, { id: userId });
                    }
                }

                break;
            case notificationStreamUtility.notificationSourceType.friendRequestAccepted:
                $scope.interactNotification(notification);
                url = notificationStreamUtility.links.friendsLink;
                if ($scope.library.inApp) {
                    params = {
                        feature: notificationStreamUtility.links.friendsTabName,
                        urlPath: url
                    };
                    hybridService.navigateToFeature(params, function (status) {
                        $log.debug("openUserFriendsPage ---- status:" + status);
                    });
                } else {
                    window.location.href = urlService.getAbsoluteUrl(url);
                }
                break;
            case notificationStreamUtility.notificationSourceType.privateMessageReceived:
                $scope.interactNotification(notification);
                if (notification.eventCount > 1 || (notification.metadataCollection.length === 0)) {
                    url = notificationStreamUtility.links.inboxLink;
                } else if (notification.metadataCollection && notification.metadataCollection.length > 0) {
                    var validData = notification.metadataCollection[0];
                    url = notificationStreamUtility.links.inboxLink + notificationStreamUtility.links.inboxMessageDetailQuery + validData.MessageId;
                }

                if ($scope.library.inApp) {
                    params = {
                        feature: notificationStreamUtility.links.inboxTabName,
                        urlPath: url
                    };
                    hybridService.navigateToFeature(params, function (status) {
                        $log.debug("openUserProfile ---- status:" + status);
                    });
                } else {
                    window.location.href = urlService.getAbsoluteUrl(url);
                }
                break;
            case notificationStreamUtility.notificationSourceType.developerMetricsAvailable:
                $scope.interactNotification(notification);
                break;
        }
    }

    $scope.notificationSourceType = notificationStreamUtility.notificationSourceType;

    // Content view manager to support switching between the default
    // notification view and  Game Updates view.
    $scope.contentViewManager = function () {
        var contentViews = {}, manager = {};

        manager.addContentView = function (viewScope) {
            contentViews[viewScope.viewId] = viewScope;
        };

        manager.selectContentView = function (viewId) {
            var viewScope = contentViews[viewId];

            if (!viewScope) { return; }

            angular.forEach(contentViews, function (vScope) {
                vScope.isActive = false;
            });

            viewScope.isActive = true;
        };

        return manager;
    }();

    $document.bind(
        "Roblox.Popover.Status",
        function (event, args) {
            $log.debug("notificationsController");

            // Go to main content view when notification stream is being opened.
            if (!args.isOpen) {
                $scope.contentViewManager.selectContentView($scope.library.notificationContentViews.main);
            }
        }
    );
}

notificationStreamModule.controller('notificationsController', notificationsController);

export default notificationsController;